import React from "react";
import Field from "./Field";
import { controlClasses } from "./control";

export default function TextArea({
  label,
  size = "sm",
  minHeight = 80,
  hint,
  wrapperClassName,
  className,
  ...rest
}) {
  const control = (
    <textarea
      style={{ minHeight }}
      className={controlClasses(size, className)}
      {...rest}
    />
  );

  if (!label) return control;

  return (
    <Field label={label} hint={hint} className={wrapperClassName}>
      {control}
    </Field>
  );
}
